<template>
  <div class="ps-card" v-if="loading == false">
    <div class="ps-rail" :style="{ backgroundColor: cfg.accent }" />
    <div
      class="ps-tint"
      :style="{ background: 'linear-gradient(100deg, ' + cfg.accent + '12, transparent 45%)' }"
    />
    <div class="ps-body">
      <div class="ps-top">
        <div class="ps-eyebrow-wrap">
          <div class="ps-icon" :style="{ backgroundColor: cfg.accent + '1A' }">
            <svg-icon name="compass" :size="16" :color="cfg.accent" />
          </div>
          <span class="ps-eyebrow">{{ cfg.eyebrow }}</span>
        </div>
        <span class="ps-updated">
          <span class="ps-dot" :style="{ backgroundColor: cfg.accent }" />
          Updated just now
        </span>
      </div>

      <p class="ps-headline">{{ cfg.headline }}</p>
      <!-- Summary copy is app-authored template text (never user input), so v-html is safe here. -->
      <p class="ps-summary" v-html="cfg.summaryHtml" />

      <div class="ps-actions" v-if="cfg.actions">
        <button
          v-for="(action, i) in cfg.actions"
          :key="action.label"
          type="button"
          class="ps-action"
          :style="
            i === 0
              ? { backgroundColor: cfg.accent, color: '#fff' }
              : { color: cfg.accent, border: '1px solid ' + cfg.accent + '55' }
          "
          @click="onAction(action)"
          v-html="action.svg + action.label"
        >
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from './icons';
import axios from 'axios';
import router from '../../router/index.js';

var NAVY = '#002F42';
var BLUE = '#00ACEE';
var ACCENT = '#EE4200';
var GREEN = '#009118';
var PURPLE = '#795EFF';

function em(text, color) {
  return (
    '<strong style="font-weight:600;color:' + (color || NAVY) + '">' + text + '</strong>'
  );
}

function firstName(name) {
  return String(name).split(' ')[0];
}

export default {
  name: 'PlatformSummary',
  components: { SvgIcon },
  props: {
    role: { type: String, required: true },
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      cfg: {
        accent: BLUE,
        eyebrow: '',
        headline: '',
        summaryHtml: '',
        actions: [],
      },
      loading: false,
    }
  },
  methods: {
    summary() {
      this.loading = true;
      axios.post('/desktop/platformsummary', {
        role: this.role,
        accountId: this.$store.state.user_accountid,
      })
      .then((resp) => {
        var data = resp.data;
        var a2 = [];
        if(data.role == 'mentor') {
          this.cfg.accent = PURPLE;
          this.cfg.eyebrow = 'Coaching Snapshot';
          if(data.action == 'open-reps-review') {
            a2.push({ id: 'open-reps-review', label: 'Reps to Review', svg : '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check h-3.5 w-3.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/PlatformSummary.tsx:306:16" data-component-name="Icon"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>' });
          }
          a2.push({ id: 'mentee-progress', label: 'View mentee progress', svg: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up h-3.5 w-3.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/PlatformSummary.tsx:306:16" data-component-name="Icon"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>' });
          this.cfg.actions = a2;
        }
        else if(data.role == 'manager') {
          this.cfg.accent = GREEN;
          this.cfg.eyebrow = 'Team Snapshot';
          if(data.action == 'open-reps-review') {
            a2.push({ id: 'open-reps-review', label: 'Reps to Review', svg : '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check h-3.5 w-3.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/PlatformSummary.tsx:306:16" data-component-name="Icon"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>' });
          }
          a2.push({ id: 'mentee-progress', label: 'View mentee progress', svg: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up h-3.5 w-3.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/PlatformSummary.tsx:306:16" data-component-name="Icon"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>' });
          this.cfg.actions = a2;
        }
        else if(data.role == 'mentee') {
          this.cfg.accent = BLUE;
          this.cfg.eyebrow = 'Your Snapshot';
        }
        else {
          this.cfg.accent = BLUE;
          this.cfg.eyebrow = 'Network Snapshot';
        }
        this.cfg.summaryHtml = data.text;
        this.cfg.headline = data.headline;
        this.loading = false;
      })
      .catch(() => {
      })
      .finally(() => {
        this.loading = false;
      });

    },
    onAction(action) {
      const id = action && action.id ? action.id : '';
      if (id === 'mentee-progress') {
        router.push('/pathway-progress-report');
        return;
      }
      else {
        this.$emit('action', action);
      }
    },
  },
  created() {
    this.summary();
  },
};
</script>

<style scoped>
.ps-card {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  margin-bottom: 16px;
}
.ps-rail {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
}
.ps-tint {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.ps-body {
  position: relative;
  padding: 24px;
}
.ps-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}
.ps-eyebrow-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ps-icon {
  display: flex;
  height: 32px;
  width: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
.ps-eyebrow {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
}
.ps-updated {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #64748b;
}
.ps-dot {
  display: inline-block;
  height: 6px;
  width: 6px;
  border-radius: 9999px;
}
.ps-headline {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 600;
  color: #002f42;
}
.ps-summary {
  margin: 0;
  max-width: 48rem;
  font-size: 14px;
  line-height: 1.625;
  color: #475569;
}
.ps-actions {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.ps-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
}
.ps-hint {
  margin-left: 4px;
  font-size: 11px;
  color: #64748b;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/PlatformSummary.vue